import Combobox from '@/libs/components/src/lib/form/Combobox';
import { Region } from '@chiroup/core/types/Condition.type';
import React, { useEffect, useState } from 'react';
import { CustomizationListItem } from '../../../clinical-skills/CustomizationListItem.type';
import { SelectOption } from '../Autocomplete';

type Props = {
  onChange: (testId: number[]) => void;
  value?: number[];
  label?: string;
  showLabel?: boolean;
  className?: string;
  disabled?: boolean;
  region?: Region[];
  evaluations?: CustomizationListItem[];
};

const EvalSelect: React.FC<Props> = ({
  onChange,
  value,
  label = 'Clinical Evaluations',
  className = 'flex-1 min-w-0',
  disabled,
  region,
  evaluations,
}) => {
  const [searchOptions, setSearchOptions] = useState<SelectOption[]>([]);

  useEffect(() => {
    if (evaluations?.length) {
      let newOptions = evaluations?.map(option => ({
        value: option.userVersion || option.clinicVersion || option.ID,
        text: option.title || option.name || '',
        regions: option.regions,
      }));

      if (region && region.length) {
        newOptions = newOptions.filter(item => {
          // Check if any of the selected regions match any of the evaluation's regions
          const hasMatchingRegion = item?.regions?.some(evalRegion => region.includes(evalRegion));

          // Show if it has a matching region OR if it's already selected
          if (hasMatchingRegion || value?.includes(item.value)) {
            return item;
          }

          return false;
        });
      }

      setSearchOptions(newOptions);
    }
  }, [evaluations, value, region]);

  return (
    <Combobox
      name="evaluation"
      label={label}
      className={className}
      options={searchOptions}
      onChange={onChange}
      value={value}
      disabled={disabled}
      showLabel={false}
      placeholder={label}
    />
  );
};

export default EvalSelect;
